module.exports = __webpack_public_path__ + "static/media/5.7b06d6dc.jpg";